import { PayloadAction } from '../../../store.model';
import {
    getSelectedFocusFromRows,
    makePerformerRows,
} from '../focus-history/focus-history.function';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';

import { FocusSelectorSelectActiveForPerformerRow } from './active-for-performer-select.action';

export function focusSelectorSelectActiveForPerformerRowReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSelectActiveForPerformerRow>,
): FocusSelectorState {
    const { rowId } = action.payload;

    const updatedRows = makePerformerRows(
        state.activeFocusesForPerformer,
        rowId,
    );

    const selection = getSelectedFocusFromRows(updatedRows);

    return {
        ...state,
        activeFocusesPerformerGrid: {
            ...state.activeFocusesPerformerGrid,
            rows: updatedRows,
            sortDefs: [...state.activeFocusesPerformerGrid.sortDefs],
            selection,
        },
    };
}
